//// Application Packages
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { format } from 'date-fns'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormData,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { RadioButton, RadioButtonGroup } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const AdditionalCriminalAndMedicaidMedicareFraudExcludedIndividualsAndEntitiesQuestions =
    () => {
        //////// Hooks
        const dispatch = useDispatch()

        //////// State

        //////// Slices
        const settingsData = useSelector(selectSettings)
        const formsData = useSelector(selectForms)

        //// Slice Data
        const digital_name = settingsData?.['form']?.['digital_name']

        //////// Search Params

        //////// Methods

        // Re-Validate Data Submission
        const revalidation = async (event_name) => {
            // Update Validation State
            if (digital_name && event_name) {
                dispatch(
                    updateFormValidity({
                        digital_name: digital_name,
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            }
        }

        //////// Functional Methods

        // Handle Data Of All Fields + DatePicker (ID)
        const handleData = (e, id) => {
            if (e?.target?.name && e?.target?.value) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [e.target.name]: e.target.value,
                        },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.target?.name) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: { [e.target.name]: '' },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.length > 0 && id) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [id]: format(new Date(e?.[0]), 'MM/dd/yyyy'),
                        },
                    })
                )
                revalidation(id)
            }
            //// Start Watson Assistant Journey

            //// End Watson Assistant Journey
        }

        //////// Memoization

        //////// Effects/Side Effects

        //////////////// Render & Return
        if (
            formsData?.[digital_name]?.values?.LEIE === 'Y' &&
            formsData?.[digital_name]?.values?.LEIE2A === 'Y'
        ) {
            return (
                <>
                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.LEIE2A
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.LEIE2A
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.LEIE2A
                        }
                        legendText="Are you listed because you defaulted or are delinquent on a student loan?"
                        name="LEIE2A"
                        invalid={formsData?.[digital_name]?.errors?.LEIE2A}
                        invalidText={
                            formsData?.[digital_name]?.errors?.LEIE2AErrMsg
                        }
                    >
                        <RadioButton
                            id="LEIE2ATrue"
                            name="LEIE2ATrue"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="LEIE2AFalse"
                            name="LEIE2AFalse"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>

                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.LEIE2B
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.LEIE2B
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.LEIE2B
                        }
                        legendText="Is the student loan default or delinquency the only reason you are listed on the LEIE?"
                        name="LEIE2B"
                        invalid={formsData?.[digital_name]?.errors?.LEIE2B}
                        invalidText={
                            formsData?.[digital_name]?.errors?.LEIE2BErrMsg
                        }
                    >
                        <RadioButton
                            id="LEIE2BTrue"
                            name="LEIE2BTrue"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="LEIE2BFalse"
                            name="LEIE2BFalse"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>
                </>
            )
        }

        if (formsData?.[digital_name]?.values?.LEIE === 'Y') {
            return (
                <>
                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.LEIE2A
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.LEIE2A
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.LEIE2A
                        }
                        legendText="Are you listed because you defaulted or are delinquent on a student loan?"
                        name="LEIE2A"
                        invalid={formsData?.[digital_name]?.errors?.LEIE2A}
                        invalidText={
                            formsData?.[digital_name]?.errors?.LEIE2AErrMsg
                        }
                    >
                        <RadioButton
                            id="LEIE2ATrue"
                            name="LEIE2ATrue"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="LEIE2AFalse"
                            name="LEIE2AFalse"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>
                </>
            )
        }
    }

export default AdditionalCriminalAndMedicaidMedicareFraudExcludedIndividualsAndEntitiesQuestions
